// helpers
export function set(array: any[], index: number, element: any) {
  return [...array.slice(0, index), element, ...array.slice(index + 1)];
}

export function remove(array: any[], index: number) {
  return [...array.slice(0, index), ...array.slice(index + 1)];
}

export function insert(array: any[], index: number, element: any) {
  return [...array.slice(0, index), element, ...array.slice(index)];
}

export function move(array: any[], fromIndex: number, toIndex: number) {
  return insert(remove(array, fromIndex), toIndex, array[fromIndex]);
}

// List Class
export class ListController {
  array: any[];
  callback: Function;

  constructor(array: any[], callback: Function) {
    this.array = array;
    this.callback = callback;
  }

  set(index: number, newContent: any) {
    this.callback(set(this.array, index, newContent));
  }

  add(newContent: any) {
    this.callback([...this.array, newContent]);
  }

  remove(index: number) {
    this.callback(remove(this.array, index));
  }

  moveUp(index: number) {
    let newIndex = index === 0 ? index : index - 1;
    this.callback(move(this.array, index, newIndex));
  }

  moveDown(index: number) {
    let newIndex = index === this.array.length - 1 ? index : index + 1;
    this.callback(move(this.array, index, newIndex));
  }
}
